export const LAB_CALCULATOR = 'https://tower-lab-calculator.netlify.app';
export const STONE_CALCULATOR = 'https://tower-stone-calculator.netlify.app';
export const WORKSHOP_CALCULATOR =
  'https://tower-workshop-calculator.netlify.app';
export const MODULE_CALCULATOR = 'https://tower-module-calculator.netlify.app';
export const CELL_CALCULATOR = 'https://tower-cell-calculator.netlify.app';
export const STAT_FINDER = 'https://tower-enemy-stats.netlify.app/';
export const BOT_CALCULATOR = 'https://tower-bot-calculator.netlify.app/';
export const FARM_TRACKER = 'https://what-tier-should-i-farm.netlify.app';

export const GOLDEN_TOWER = 'Golden Tower';
export const DEATH_WAVE = 'Death Wave';
export const BLACK_HOLE = 'Black Hole';
export const CHRONO_FIELD = 'Chrono Field';
export const SPOTLIGHT = 'Spotlight';
export const INNER_LAND_MINES = 'Inner Land Mines';
export const POISON_SWAMP = 'Poison Swamp';
export const CHAIN_LIGHTNING = 'Chain Lightning';
export const SMART_MISSILES = 'Smart Missiles';

export const ULTIMATE_WEAPONS = [
  GOLDEN_TOWER,
  DEATH_WAVE,
  BLACK_HOLE,
  CHRONO_FIELD,
  SPOTLIGHT,
  INNER_LAND_MINES,
  POISON_SWAMP,
  CHAIN_LIGHTNING,
  SMART_MISSILES,
];
